// 性别
export const checkIn = [
    { value: '0', text: '否' },
    { value: '1', text: '是' },
];
